import { VisitorIdTypes } from './constants';

export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';
export const VARIANT_A = 'a';
export const VARIANT_B = 'b';

export const PCE_ACCESSIBILITY = {
    experimentId: 'PCE_Accessibility',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const BOOKING_COMPLETE_V4_VARIANTS = {
    REGULAR_MODAL: 'regularmodal',
    REMIND_ME_LATER: 'remindme',
    DO_NOT_REMIND_ME_LATER: 'donotremindmelater',
};

export const BOOKING_COMPLETE_V4 = {
    experimentId: 'BookingCompleteView_RemindMeLater',
    defaultAssignment: BOOKING_COMPLETE_V4_VARIANTS.REGULAR_MODAL,
    isFeatureFlag: false,
};

export const FULL_STORY = {
    experimentId: 'FullStory',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const FULL_STORY_BOOKING = {
    experimentId: 'FullStory-Booking',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const PINA_REMEMBER_ME = {
    experimentId: 'Pina_ExtendedSession_ShowRememberMe',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

// Static (Accordion) Review and book with new/existing validation for certain
// users
export const PCE_STATIC_WITH_NEW_EXISTING_VALIDATION = {
    experimentId: 'PCE_StaticWithNewExistingValidation',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
    recordManually: true,
};

export const ALLOW_GOVERNMENT_INSURANCE = {
    experiment: 'Choco_MasterFlag_AllowGovernmentInsurance',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.SESSION_ID,
};

export const VIRTUAL_VISITS = {
    experimentId: 'EnableVideoVisitsWithZocdocProvidersForPatients',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const ENABLE_ZOCDOC_VIDEO_VISIT_LOCATIONS = {
    experimentId: 'EnableZocdocVideoVisitLocations',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PINA_INSURANCE_ADVOCACY = {
    experimentId: 'pina_insuranceadvocacy',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PINA_BOOKING_COMPLETE_WARP_SPEED = {
    experimentId: 'Pina_BookingComplete_WarpSpeed',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const BWA_SUPPRESS_SSO = {
    experimentId: 'BWA_SuppressSso',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PCE_SIGN_IN_FACEBOOK_SSO = {
    experimentId: 'PCE_SignInFacebookSso',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
export const PCE_SIGN_IN_GOOGLE_SSO = {
    experimentId: 'PCE_SignInGoogleSso',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
export const PCE_SIGN_IN_APPLE_SSO = {
    experimentId: 'PCE_SignInAppleSso',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
export const PINA_BOOKING_COMPLETE_POBOLO = {
    experimentId: 'Pina_BookingComplete_Pobolo',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PCE_MENTAL_HEALTH_OON_BENEFITS = {
    experimentId: 'pce_mental_health_oon_benefits',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
